import { canRead, canWrite } from '../access/rbacAccess'

export const CHARGES = {
  LIST: 'ejecuta.charges'
}

export const canViewCharges = () => canRead(CHARGES.LIST)

export const canManageCharges = () => canWrite(CHARGES.LIST)

/** Detalle de factura legacy `/facturas/:id` (antes `can_view_core`). */
export const canViewInvoices = () => canViewCharges()
